import { createComponent } from '@carvana/merch-components';

export const HeroWrapper = createComponent('section', {
  className: 'relative h-fit w-full bg-grey-1'
});

export const HeroImage = createComponent('div', {
  className:
    'h-[264px] w-full bg-cover bg-[center_center] sm:bg-[30%_40%] m:h-[400px] m:bg-cover md:bg-[10%_center] xl:bg-[center_center]'
});

export const Copy = createComponent('div', {
  className: 'whitespace-nowrap'
});

export const SubCopy = createComponent('span', {
  className: 'mt-16 text-white tl-header-s m:tl-header-m'
});

export const PageTitle = createComponent('h1', {
  className:
    'mb-xl w-full text-center text-3xl font-black uppercase text-white m:text-[56px] m:leading-[52px]'
});
